import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';
import {OrganizationAddress} from '../organization/organization-address';
import {GoogleService} from './google-service';
import {AddressResolution} from '../model/address-resolution';
import {AddressUtils} from '../utils/address-utils';

@Service()
export class OrganizationAddressService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getOrganizationAddresses(organizationId: string): Observable<OrganizationAddress[]> {
    let url = this.urlBase + 'addresses/organization/' + organizationId;
    return this.http.get<OrganizationAddress[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  private getPostHeaders(contentType: string = 'application/json'): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", contentType);
  }

  public getAddress(addressId: string): Observable<OrganizationAddress> {
    let url = this.urlBase + 'addresses/' + addressId;
    return this.http.get<OrganizationAddress>(url, {headers: this.getRequestHeaders()});
  }

  public save(organizationAddress: OrganizationAddress): Observable<OrganizationAddress> {
    if (!AddressUtils.isGeneralDeliverySpecified(organizationAddress)) {
      let url = this.urlBase + 'addresses/save';
      let body = JSON.stringify(organizationAddress);
      return this.http.post<OrganizationAddress>(url, body, {headers: this.getPostHeaders()});
    } else {
      return of(organizationAddress);
    }
  }

  public setDefaultBillingAddress(organizationId: string, addressId: string): Observable<string> {
    let url = this.urlBase + 'addresses/setDefaultBilling?orgId=' + organizationId;
    return this.http.post(url, addressId, {headers: this.getPostHeaders('text/plain'), responseType: 'text'});
  }

  public setDefaultShippingAddress(organizationId: string, addressId: string): Observable<string> {
    let url = this.urlBase + 'addresses/setDefaultShipping?orgId=' + organizationId;
    return this.http.post(url, addressId, {headers: this.getPostHeaders('text/plain'), responseType: 'text'});
  }

  validateAddress(organizationAddress: OrganizationAddress): Observable<AddressResolution> {
    const url = this.urlBase + 'addresses/validateAddress';
    const body = JSON.stringify(organizationAddress);
    return this.http.post<AddressResolution>(url, body, {headers: this.getPostHeaders()});
  }

}
